import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AUTH_TOKEN_URL = "https://weavevo.com/auth/realms/master/protocol/openid-connect/token";
const AUTH_CLIENT_ID = "weavevo-frontend";
const AUTH_REDIRECT_URI = "https://weavevo.com/auth/callback";
const DEFAULT_POST_LOGIN_TARGET = "/public";
const POST_LOGIN_TARGET_KEY = "weavevo_post_login_target";

const getPostLoginTarget = () => {
  try {
    const target = sessionStorage.getItem(POST_LOGIN_TARGET_KEY);
    return target && target.startsWith("/") ? target : DEFAULT_POST_LOGIN_TARGET;
  } catch {
    return DEFAULT_POST_LOGIN_TARGET;
  }
};

const AuthHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (!code) {
      navigate("/", { replace: true });
      return;
    }

    const fetchToken = async () => {
      try {
        const response = await fetch(AUTH_TOKEN_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            client_id: AUTH_CLIENT_ID,
            grant_type: "authorization_code",
            code,
            redirect_uri: AUTH_REDIRECT_URI,
          }),
        });

        if (!response.ok) throw new Error("Erreur échange code/token");

        const data = await response.json();
        const token = data.access_token;
        const payload = JSON.parse(atob(token.split(".")[1]));

        login(token, {
          name: payload.name,
          email: payload.email,
          preferred_username: payload.preferred_username,
          username: payload.preferred_username || payload.email,
        });

        const postLoginTarget = getPostLoginTarget();
        try {
          sessionStorage.removeItem(POST_LOGIN_TARGET_KEY);
        } catch {}

        navigate(postLoginTarget, { replace: true });
        window.setTimeout(() => {
          if (window.location.pathname !== postLoginTarget) {
            window.location.replace(postLoginTarget);
          }
        }, 0);
      } catch (err) {
        console.error("Erreur Google Login:", err);
        navigate("/", { replace: true });
      }
    };

    fetchToken();
  }, [location.search, login, navigate]);

  return <div>Connexion en cours...</div>;
};

export default AuthHandler;
